import React from 'react';
import {lobbyTabsEnum} from '../cellcomAbroadVariables';
import {connect} from 'react-redux';
import SubMainHeadlineComponent from '../SubMainHeadLineComponent';
import AbroadPackagePopular from '../Shared/Components/AbroadPackagesPopular';
import {ClientType, PackageOrigin} from '../Shared/Models/AbroadPackageModels';
import gaParams from '../../../../utilities/analytics/constants';
import {gaEvent, gtag4} from '../../../../utilities/analytics/tracking';

const CellcomAbroadPopularPackagesHolderComponent = (props) => {
  const requestPopular = React.useMemo(() => {
    if (props.data.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT && props.data.otpData.isOTPValidated) {
      return {
        socIdList: props.data.epiStyleInitializationData.listOfBusinessPopularSocIds,
        blockId: props.lobbyBlockId,
        clientType: ClientType.BUSINESS,
      };
    } else {
      return {
        socIdList: props.data.epiStyleInitializationData.listOfPrivatePopularSocIds,
        blockId: props.lobbyBlockId,
        clientType: ClientType.PRIVATE,
      };
    }
  }, [
    props.lobbyBlockId,
    props.data.epiStyleInitializationData.listOfBusinessPopularSocIds,
    props.data.otpData.isOTPValidated,
    props.data.activeLobbyTab,
  ]);

  const gaAndOrder = (selectedPackage) => {
    switch (props.data.activeLobbyTab) {
      case lobbyTabsEnum.PRIVATE:
        gtag4({
          event: 'CellcomAbroad_Step3_PackageCtaClick',
          button: selectedPackage?.buttonValue,
          package_name: selectedPackage?.socCode,
          badge: selectedPackage?.tagTextSecondary,
          title: selectedPackage?.titleEpi,
          content: selectedPackage?.textUnderPackage,
          step: '3',
          action: 'PackageCtaClick',
          process_type: 'private',
          funnel_name: '1 - Lobby',
        });
        break;
      case lobbyTabsEnum.BUSINESSACCOUNT:
        if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
          gaEvent(
            gaParams.SEPARATED_PURCHASEBUTTON_CLICK.category,
            gaParams.SEPARATED_PURCHASEBUTTON_CLICK.eventType,
            selectedPackage.socCode,
          );
        } else {
          gtag4({
            event: 'CellcomAbroad_Step2_PackageContinueButton',
            button: selectedPackage?.buttonValue,
            package_name: selectedPackage?.socCode,
            badge: selectedPackage?.tagTextSecondary,
            title: selectedPackage?.titleEpi,
            content: selectedPackage?.textUnderPackage,
            step: '2',
            action: 'PackageContinueButton',
            process_type: 'business',
            funnel_name: '2 - SearchArea - Business',
          });
        }
        break;
      default:
        break;
    }
    props.orderEvent(selectedPackage);
  };
  return (
    <div className='packages-wrapper'>
      {props.data.abroadPackagesPopular?.length > 0 && (
        <SubMainHeadlineComponent
          title={`חבילות חו"ל שיעשו לכם את הטיול`}
          isSmallResolution={props.data.isSmallResolution}
          isPortrait={props.data.isPortrait}
        />
      )}

      <div className='packages-holder'>
        <AbroadPackagePopular
          requestPackagePopular={requestPopular}
          orderEvent={(selectedPackage) => gaAndOrder(selectedPackage)}
          isLobby={true}
          context={props.context}
          isPopularMarketOrLobby={PackageOrigin.POPULAR}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.cellcomAbroad,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CellcomAbroadPopularPackagesHolderComponent);
